import Vuex  from 'vuex'
import Vue from 'vue'

Vue.use(Vuex);
const store = new Vuex.Store({

    state(){
        return {
            dostup: 0,
            login: '',
            parol:'',
            id_user: '',
            kod: 0,

            //autolock
            idleVue: {
                isIdle: false,
            }
        }
    },
    mutations:{

        dostup(state, payload){
            state.dostup = payload;
        },
        login(state, payload){
            state.login = payload;
        },
        parol(state, payload){
            state.parol = payload;
        },
        kod(state, payload){
            state.kod = payload;
        },
        id_user(state, payload){
            state.id_user = payload;
        },



    }
})



export default store;

